export const isCurrent = ({
    index,
    offset,
}):boolean => index === offset;

